import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {App} from './App';
// https://github.com/mobxjs/mobx-react#observer-batching
import 'mobx-react/batchingForReactDom';

ReactDOM.render(<App />, document.getElementById('root'));
